import styled from 'styled-components';
export const Td = styled.td.withConfig({
  displayName: "StyledComponents__Td",
  componentId: "pd1vzj-0"
})(["position:relative;"]);